
<div class="container">
  <div class="container mt-5 text-center">
    <h3  class="display-5 fw-light" style="color: var(--secondary-color);">¿Por qué es <span class="fw-bold"> importante?</span></h3>
  </div>
  <div class="container w-75 mx-auto text-start">
    <ul style="list-style: none;">
      <li *ngFor="let listItem of listItems" class="mt-3 text-secondary">
        <i style="color: var(--terciary-color); font-size: .7rem" class="bi bi-circle-fill"></i>
        {{ listItem.texto }}
      </li>
    </ul>
  </div>
</div>





<div class="container py-5 ">

  <div class="container text-center">
    <p class="fw-lighter fs-5 pt-2" style="color: var(--primary-color)">Más información al:</p>
  </div>


  <div class="d-grid gap-2 d-sm-flex justify-content-sm-center">
    <button class="buttonAction d-flex align-items-center justify-content-center">
      <img ngSrc="assets/img/movilink/llamadaIcon.svg" alt="llamadaLogo" class=" flex-shrink-0" height="30" width="30">
      <span class="text-light px-2 fs-1">5 50 50 52</span>
    </button>
    <a href="https://api.whatsapp.com/send/?phone=%2B593993183975&text&type=phone_number&app_absent=0" target="_blank" class="buttonAction d-flex align-items-center justify-content-center">
      <img ngSrc="assets/img/movilink/whatsapLogo.svg" alt="whatsapLogo" class=" flex-shrink-0" height="30" width="30">
      <span class="text-light px-2 fs-1">099 318 3975</span>
    </a>
  </div>



</div>
